import React, { useState } from "react";
import { Mutation } from "react-apollo";

import Information from "./Information";
import activateTrainingUnitMutation from "../../../../gql/activateTrainingUnitMutation";
import cancelTrainingUnitMutation from "../../../../gql/cancelTrainingUnitMutation";
import { toastTranslated } from "../../../../toastr/toastr";
import { isAfter } from "date-fns";

function InformationContainer({
  trainingUnit,
  onUpdateTrainingUnit,
  isAdminView
}) {
  const [isCancelModalOpen, setCancelModalOpen] = useState(false);

  const handleCloseCancelModal = () => {
    setCancelModalOpen(false);
  };

  const handleOpenCancelModal = () => {
    setCancelModalOpen(true);
  };

  const handleActivate = mutateFunc => () => {
    mutateFunc({
      variables: {
        id: trainingUnit.id
      }
    }).then(() => {
      toastTranslated("success", "coursePlan.events.activated");

      onUpdateTrainingUnit();
    });
  };

  const handleCancel = mutateFunc => cancelCause => {
    mutateFunc({
      variables: {
        input: {
          id: trainingUnit.id,
          cancelCause
        }
      }
    }).then(() => {
      toastTranslated("success", "coursePlan.events.cancelled");

      onUpdateTrainingUnit();
    });
  };

  let canCancelTrainingUnit = false;
  let canActivateTrainingUnit = false;

  if (isAdminView && isAfter(new Date(trainingUnit.date), new Date())) {
    canCancelTrainingUnit = true;
    canActivateTrainingUnit = true;
  }

  return (
    <Mutation mutation={activateTrainingUnitMutation} ignoreResults={false}>
      {activateFunc => (
        <Mutation mutation={cancelTrainingUnitMutation} ignoreResults={false}>
          {cancelFunc => (
            <Information
              trainingUnit={trainingUnit}
              isCancelModalOpen={isCancelModalOpen}
              onOpenCancelModal={handleOpenCancelModal}
              onCloseCancelModal={handleCloseCancelModal}
              canCancelTrainingUnit={canCancelTrainingUnit}
              canActivateTrainingUnit={canActivateTrainingUnit}
              onActivate={handleActivate(activateFunc)}
              onCancel={handleCancel(cancelFunc)}
            />
          )}
        </Mutation>
      )}
    </Mutation>
  );
}

InformationContainer.displayName =
  "coursePlan/details/information/InformationContainer";

export default React.memo(InformationContainer);
